import React from 'react';
import { examCategories } from '../mock';
import {
  GraduationCap,
  Landmark,
  Atom,
  Stethoscope,
  Banknote,
  TrainFront,
  Shield,
  Building2,
} from 'lucide-react';

const iconMap = {
  GraduationCap,
  Landmark,
  Atom,
  Stethoscope,
  Banknote,
  TrainFront,
  Shield,
  Building2,
};

export default function ExamCategories() {
  return (
    <section className="py-20 relative">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-extrabold text-white tracking-tight">
            50+ Exam Categories
          </h2>
          <p className="mt-3 text-slate-400">One platform for all your exam preparation needs</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {examCategories.map((cat) => {
            const Icon = iconMap[cat.icon];
            return (
              <div
                key={cat.name}
                className="group relative rounded-xl border border-white/5 bg-[#0f1725] hover:border-emerald-500/40 hover:bg-[#12203a] transition-all duration-300 p-6 cursor-pointer"
              >
                <div className="w-12 h-12 rounded-lg bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center mb-4 group-hover:bg-emerald-500/20 transition-colors">
                  <Icon className="text-emerald-400" size={24} />
                </div>
                <h3 className="text-white font-bold text-lg">{cat.name}</h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
